var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.835 7h1.003l-1.724 21.62A1.506 1.506 0 0 1 23.62 30H8.381a1.506 1.506 0 0 1-1.495-1.38L5.162 7h1.003l1.717 21.54a.503.503 0 0 0 .499.46h15.238a.503.503 0 0 0 .5-.46zM19.5 25a.501.501 0 0 0 .5-.5v-14a.5.5 0 0 0-1 0v14a.501.501 0 0 0 .5.5zm-7 0a.501.501 0 0 0 .5-.5v-14a.5.5 0 0 0-1 0v14a.501.501 0 0 0 .5.5zM29 5v1H3V5h8V3.5A1.502 1.502 0 0 1 12.5 2h7A1.502 1.502 0 0 1 21 3.5V5zm-9 0V3.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash32);
export default __webpack_public_path__ + "static/media/trash-32.2d2ae22f3c87c6b2957d04325e7a54f1.svg";
export { ForwardRef as ReactComponent };